/**
 * 将单精度浮点数转换为十六进制字符串 (IEEE 754)
 * @param {number|string} decimal - 十进制数
 * @returns {string} 十六进制字符串
 */
export function singleToHex(decimal) {
  if (decimal === '' || decimal === null || decimal === undefined) {
    return ''
  }
  
  const num = parseFloat(decimal)
  
  if (isNaN(num)) {
    throw new Error('无效的数字')
  }
  
  // 使用 TypedArray 进行 IEEE 754 编码
  const buffer = new ArrayBuffer(4)
  const floatView = new Float32Array(buffer)
  const intView = new Uint32Array(buffer)
  
  floatView[0] = num
  const intRepresentation = intView[0]
  
  // 转换为十六进制字符串，补齐到8位
  const hex = intRepresentation.toString(16).toUpperCase().padStart(8, '0')
  
  return hex
}

/**
 * 将十六进制字符串转换为单精度浮点数 (IEEE 754)
 * @param {string} hex - 十六进制字符串
 * @returns {number} 十进制浮点数
 */
export function hexToSingle(hex) {
  if (!hex || hex === '') {
    return ''
  }
  
  // 移除可能的空格和0x前缀
  const cleanHex = hex.trim().replace(/^0x/i, '')
  
  // 验证十六进制格式
  if (!/^[0-9A-Fa-f]{1,8}$/.test(cleanHex)) {
    throw new Error('无效的十六进制格式')
  }
  
  // 转换为整数
  const intValue = parseInt(cleanHex, 16)
  
  // 使用 TypedArray 进行 IEEE 754 解码
  const buffer = new ArrayBuffer(4)
  const intView = new Uint32Array(buffer)
  const floatView = new Float32Array(buffer)
  
  intView[0] = intValue
  const result = floatView[0]
  
  return result
}
